import React from 'react';
import './../index.css';

const sizeClasses = {
  h1: 'text-4xl md:text-6xl font-normal tracking-tight uppercase',
  h2: 'text-3xl md:text-4xl my-5 font-medium',
  h3: 'text-xl md:text-2xl',
  h4: 'text-md md:text-xl mb-2',
};

const Title = ({ as: Component = 'h1', children, className = '', ...props }) => {
  const baseClasses = 'text-midground';
  const classes = [baseClasses, sizeClasses[Component] || sizeClasses.h1, className]
    .filter(Boolean)
    .join(' ');

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
};

export default Title;